import React from "react";
import { motion } from "framer-motion";
import { FileText } from "lucide-react";
import { Button } from "../ui/button";

export default function AboutSection({
  hotel,
  hotelImages,
  openPhotoViewer,
  onShowRules,
  photosPositions = {},
  accentColor = "#14b8a6",
  textColor,
}) {
  return (
    <section
      id="about"
      className="py-20 bg-gray-50 overflow-x-hidden"
      style={{
        color: textColor,
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span
              className="inline-block px-4 py-1.5 bg-teal-100 text-teal-700 text-sm font-medium rounded-full mb-4"
              style={{
                backgroundColor: `${accentColor}20`,
                color: textColor,
              }}
            >
              О нас
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              {hotel?.name}
            </h2>
            <div
              className="space-y-4 text-gray-600 leading-relaxed"
              style={{ whiteSpace: "pre-line" }}
            >
              {hotel.description || ""}
            </div>

            {hotel?.rules_of_residence && (
              <Button
                onClick={onShowRules}
                className="mt-6 bg-teal-600 hover:bg-teal-700 text-white"
                style={{ backgroundColor: accentColor, color: textColor }}
              >
                <FileText className="w-4 h-4 mr-2" />
                Правила проживания
              </Button>
            )}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="grid grid-cols-2 gap-4"
          >
            {hotelImages?.length >= 5 &&
              hotelImages.slice(2, 6).map((p, i) => (
                <img
                  key={i}
                  src={p.src}
                  onClick={() => openPhotoViewer(hotelImages, i)}
                  className={`w-full h-64 object-cover rounded-2xl shadow-lg cursor-pointer hover:opacity-90 transition-opacity ${
                    i === 1 ? "mt-8" : i === 2 ? "-mt-8" : ""
                  }`}
                  style={{
                    objectPosition: photosPositions?.[p.name] || "",
                  }}
                />
              ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
